import script from "./lista-usuarios.vue?vue&type=script&setup=true&lang=js"
export * from "./lista-usuarios.vue?vue&type=script&setup=true&lang=js"

import "./lista-usuarios.vue?vue&type=style&index=0&id=10556501&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10556501"]])

export default __exports__